import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { OrganizationVehicleEdit, OrganizationVehiclesVM } from '../../../../../models/orderModel';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-org-vehicle-edit',
  standalone: false,
  templateUrl: './org-vehicle-edit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './org-vehicle-edit.component.css'
})
export class OrgVehicleEditComponent {
  @Output() saveChangesEvent = new EventEmitter<OrganizationVehiclesVM>();
  vehicleForm: UntypedFormGroup;
  isLoading: boolean = false;

  constructor(
    private backOfficeService: BackOfficeService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    @Inject(MatDialogRef<OrgVehicleEditComponent>) private dialogRef: MatDialogRef<OrgVehicleEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      vehicle: OrganizationVehicleEdit,
      gates: any[],
      organization: MyConfigOrganization,
      edit: boolean
    }) { }

  ngOnInit(): void {
    if (this.data.edit) {
      this.initVehicleForm();
    } else {
      this.emptyVehicleForm();
    }
  }

  emptyVehicleForm() {
    this.vehicleForm = this.formBuilder.group({
      organizationId: this.data.organization.organizationId,
      regNo: [{ value: '', disabled: this.isLoading }, [Validators.required, Validators.maxLength(10)]],
      gates: [{ value: [], disabled: this.isLoading }],
      comment: [{ value: '', disabled: this.isLoading }]
    });
  }

  initVehicleForm() {
    this.vehicleForm = this.formBuilder.group({
      organizationId: this.data.vehicle.organizationId,
      regNo: [{ value: this.data.vehicle.regNo, disabled: this.isLoading }, [Validators.required, Validators.maxLength(10)]],
      gates: [{ value: this.data.vehicle.gates, disabled: this.isLoading }],
      comment: [{ value: this.data.vehicle.comment, disabled: this.isLoading }]
    });
  }

  formatVehicleNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formattedValue = input.value.replace(/\s+/g, '').toUpperCase();
    this.vehicleForm.get('regNo')?.setValue(formattedValue, { emitEvent: false });
  }

  saveChanges(): void {
    if (this.vehicleForm.invalid) {
      return;
    }

    this.isLoading = true;

    const model: OrganizationVehicleEdit = {
      organizationId: this.data.organization.organizationId,
      regNo: this.vehicleForm.get('regNo')?.value,
      comment: this.vehicleForm.get('comment')?.value,
      gates: this.vehicleForm.get('gates')?.value
    };

    if (this.data.edit) {
      model.vehicleId = this.data.vehicle.vehicleId;
    }

    this.backOfficeService.editOrganizationVehicleInfo(model)
      .subscribe({
        next: (result: OrganizationVehiclesVM) => {
          this.isLoading = false;
          this.saveChangesEvent.emit(result);
          this.dialogRef.close();
        },
        error: (error) => {
          this.isLoading = false;
          this.snackBar.open(error?.error?.error || 'An error occurred while saving the vehicle', 'Close', {
            duration: 4000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['error-snackbar']
          });
        }
      });
  }
}
